.ProfileModal{
  position: absolute;
  top: var(--topbar-desktop-height);
  background: rgba(0, 0, 0, 0.45);
  width: 100%;
  height: calc(100% - var(--topbar-desktop-height));
  z-index:99;
  padding-top: 40px;
  padding-bottom: 40px;
}

.Close {
  display: flex;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 44px;
  height: 44px;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: var(--colori-neutri-white);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.Close:hover,
.Close:active {
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.1) 0%,
      rgba(0, 0, 0, 0.1) 100%
    ),
    #fff;
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
}


.ProfileContent {
  background-color: var(--colori-neutri-white);
  height: 100%;
  border-radius: 30px;
  display: flex;
  overflow-y: auto;
  position: relative;
}

.ProfileContainer {
  display: flex;
  padding: 16px 32px 16px 32px;
  flex-direction: column;
  align-items: center;
  gap: 56px;
  flex: 1 0 0;
  align-self: stretch;
  width: 100%;
}

.ProfileContainerUser {
  display: flex;
  padding: 16px 32px 0px 32px;
  flex-direction: column;
  gap: 56px;
  flex: 1 0 0;
  align-self: stretch;
  width: 100%;
}

.UserLabel {
  color: var(--colori-neutri-gray);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.NomeUtente {
  color: var(--primary);
  /* Body Desktop */
  font-family: var(--font-roboto-slab);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.LogoutButton {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  width: 100%;
  border: none;
  /* Shade Button Light */
  box-shadow: 1px 1px 0px 0px rgba(17, 138, 178, 0.23);
  color: var(--colori-neutri-gray);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}

.LogoutButton:hover {
  background: var(--primary);
  color: var(--colori-neutri-white);
}

.LogoutButton:hover > svg > path {
  fill: var(--colori-neutri-white);
}

.BlockChangeLanguage {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.BlockChangeLanguage {
  color: var(--primary);
  margin-right: 8px;
  /* Label */
  font-family: var(--font-roboto-slab);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.ButtonChangeLanguage {
  display: flex;
  width: 32px;
  height: 32px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  background: var(--primary);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  border: none;
}

.TextLogin {
  color: var(--colori-neutri-gray);
  text-align: center;
  /* H1 */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.TextLogin {
  color: var(--colori-neutri-gray);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 32px;
}

.LoginButton {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--secondary);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--primary);
  width: 100%;
  border: none;
  color: var(--colori-neutri-white);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  transition: all 0.3s ease-in-out;
}

.LoginButton:hover {
  background: var(--primary);
}

.LoginEffettuato {
  color: var(--colori-neutri-gray);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.ButtonImagesProfile {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 16px 24px;
  height: 100%;
  border-radius: 8px;
  background: var(--secondary);
  color: var(--colori-neutri-white);
  border: none;
  margin-top: 32px;
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 16px;
}

.ButtonImagesProfile:hover {
  background: var(--primary);
}

.BlockCambioLingua {
  display: flex;
  width: 257px;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 30px;
  background: var(--overlay);
  margin: 16px;
}

.TitoloCambiaLingua {
  color: var(--primary);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 0.5px solid var(--primary);
  padding-bottom: 8px;
}

.OrderingItem {
  display: flex;
  height: 34px;
  padding: 8px 0px 8px 24px;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  border-radius: 5px;
  background: var(--colori-neutri-white);
  color: var(--primary-color, #118ab2);
  text-align: center;
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 8px;
  cursor: pointer;
}

.OrderingItemActive {
  background: var(--primary);
  color: var(--colori-neutri-white);
  cursor: pointer;
}

.ListOrderingItems{
    width: 100%;
}

.ProfileOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.ResponseOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.2);
  padding: 24px 16px;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.TextBeforeLogin {
  color: var(--primary);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.License {
  display: flex;
  align-items: center;
  color: var(--colori-neutri-dark-gray);
  /* Body */
  font-family: var(--font-roboto-slab);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.ResponseContainer {
  display: flex;
  width: 40%;
  height: 592px;
  padding: 16px 64px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: 71px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--overlay);
}

.ButtonAccetta {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 100%;
  align-self: stretch;
  border-radius: 5px;
  background: var(--concorso);
  /* Shade Button Blu */
  box-shadow: 1px 1px 0px 0px var(--concorso-shadow);
  border: none;
  color: var(--colori-neutri-white, #fff);
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
